var React = require('react');

function LongArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_16191","data-name":"Group 16191","transform":"translate(52.822 0.707) rotate(90)"},[React.createElement("path",{"id":"Path_19","data-name":"Path 19","d":"M0,0V51.707","transform":"translate(8.062)","fill":"none","stroke":"#285c3f","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_20","data-name":"Path 20","d":"M0,0H11.4V11.4","transform":"translate(16.124 43.346) rotate(135)","fill":"none","stroke":"#285c3f","strokeWidth":"2","key":1})]));
}

LongArrow.defaultProps = {"width":"52.822","height":"17.539","viewBox":"0 0 52.822 17.539"};

module.exports = LongArrow;

LongArrow.default = LongArrow;
